var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.convertSource(_vm.source, _vm.isDark),"width":"25px","height":"25px","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }